import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { MunicipiosService } from 'src/app/services/municipios.service';
import { DadosCargasService } from 'src/app/services/dados-cargas.service';

@Component({
    selector: 'app-modal-cadastro-municipios',
    templateUrl: './modal-cadastro-municipios.component.html',
    providers: [MunicipiosService]
})

export class ModalCadastroMunicipiosComponent implements OnInit {

    modalRef: NgbModalRef;
    public municipio: any;
    public listaEstados = [];

    constructor(
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        private appService: AppService,
        private municipiosService: MunicipiosService,
        private dadosCargasService: DadosCargasService,
    ) {

    }

    popularNovoMunicipio() {
        this.municipio = {
            nome: '',
            estado: '',
        };
    }

    ngOnInit(): void {
        this.popularNovoMunicipio();
        this.listaEstados = this.dadosCargasService.mockEstados();
    }

    cadastrar() {
        this.add(this.municipio);
    }

    add(municipio) {
        this.spinner.show();
        this.toastrService.clear();
        this.municipiosService.add(municipio)
            .subscribe(res => {
                this.toastrService.success("Município cadastrado.", "Sucesso");
                this.modalRef.close({ result: true, page: this.modalRef.componentInstance.page, acao: 'cadastrado' });
            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível cadastrar o município!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    close() {
        this.modalRef.close();
    }

    dismiss() {
        this.modalRef.dismiss();
    }
}